import Section from '@app/components/atoms/Section/Section'
import { formatParamsFilter } from '@app/libs/formatParamsFilter'
import { createFilters, isEmptyFilters, toDefaultValues, toFilters, toValues } from '@app/libs/tableUtil'
import { Inertia } from '@inertiajs/inertia'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import FilterChip from './FilterHomeChip'
import FilterField from './FilterHomeField'

const Filter = ({ filters = [], onFilter = () => {}, expandable, nameRoute }) => {
  const initialValues = createFilters(filters)
  const filterForm = useForm({
    defaultValues: toValues(initialValues),
  })
  const onSubmit = (values) => {
    onFilter(values)
    const checkFilter = formatParamsFilter(values)
    Inertia.visit(route(nameRoute, { ...checkFilter }), {
      preserveState: true,
      preserveScroll: true,
    })
  }

  const [isExpand, setIsExpand] = useState(false)
  const { t } = useTranslation()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('lg'))
  if (initialValues.length) {
    return (
      <Section>
        <Grid container component="form" spacing={2} onSubmit={filterForm.handleSubmit(onSubmit)}>
          <Grid item md={8} xs={12}>
            <Grid container spacing={2}>
              {initialValues.map((filter, key) => (
                <FilterChip
                  filter={filter}
                  filterForm={filterForm}
                  key={key}
                  onFilter={onFilter}
                  routeName={nameRoute}
                />
              ))}

              {!isEmptyFilters(initialValues) && (
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item md={8} xs={12}>
            <Grid container spacing={2}>
              {initialValues
                .filter((data) => isExpand || !data.autoHide)
                .map((filter, key) => (
                  <Grid item key={key} lg={4} md={6} xs={12}>
                    <FilterField filter={filter} filterForm={filterForm} />
                  </Grid>
                ))}
            </Grid>
          </Grid>
          <Grid item md={4} xs={12}>
            <Grid container justifyContent="flex-end" spacing={2}>
              <Grid item xs="auto">
                <Button color="primary" type="submit" variant="contained">
                  {t('BUTTON.FILTER')}
                </Button>
              </Grid>

              <Grid item xs="auto">
                <Button
                  color="inherit"
                  sx={{ color: 'black' }}
                  type="reset"
                  variant="contained"
                  onClick={() => {
                    filterForm.reset(toDefaultValues(filters))
                    onSubmit(toDefaultValues(filters))
                  }}
                >
                  {t('BUTTON.RESET')}
                </Button>
              </Grid>
              {expandable && (
                <Grid item xs="auto">
                  {isSmall ? (
                    <Button variant="outlined" onClick={() => setIsExpand((prev) => !prev)}>
                      {isExpand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Button>
                  ) : (
                    <Button
                      style={{ width: '120px', whiteSpace: 'nowrap' }}
                      variant="outlined"
                      onClick={() => setIsExpand((prev) => !prev)}
                    >
                      {isExpand ? (
                        <>
                          {t('BUTTON.COLLAPSE')} <ExpandLessIcon />
                        </>
                      ) : (
                        <>
                          {t('BUTTON.EXPAND')} <ExpandMoreIcon />
                        </>
                      )}
                    </Button>
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Section>
    )
  }

  return null
}

export default Filter
